import { Dialog } from "primereact/dialog";
import { useHideTimeSpent } from "sj-ui-toolkit/src/integrations";

interface ScoringRulesDialogProps {
  visible: boolean;
  onHide: () => void;
}

export function ScoringRulesDialog({ visible, onHide }: ScoringRulesDialogProps) {
  const hideTimeSpent = useHideTimeSpent();
  return (
    <Dialog style={{ width: "650px" }} visible={visible} onHide={onHide} header="Scoring Rules">
      <div>
        <p className="font-bold mb-2 atlas-h4">Tournament Scoring Details</p>
        <ul className="list-disc list-outside pl-6 space-y-3">
          <li>
            Each activity is worth 100-200 possible points. The lowest you can score in an activity
            is 10 points.
          </li>
          <li>Points are deducted for each hint used and each incorrect code submission.</li>
          {!hideTimeSpent && (
            <li>
              If there is a tie, the participant with the least amount of time spent in the
              tournament will win
            </li>
          )}
        </ul>
      </div>
      <div>
        <p className="font-bold mt-4 mb-2 atlas-h4">Additional Details</p>
        <ul className="list-disc list-outside pl-6 space-y-3">
          <li>
            Video lessons must be completed with a score of 80% or above. Additional attempts will
            deduct 10 points from your score.
          </li>
          <li>
            If a video lesson contains a coding exercise, the coding exercise must also be completed
            to successfully complete the lesson.
          </li>
          <li>Hints used will deduct 5 points. The final hint will deduct 10 points.</li>
        </ul>
      </div>
    </Dialog>
  );
}
